import { AfterViewInit, Component } from '@angular/core';

@Component({
  selector: 'app-our-tasks',
  templateUrl: './our-tasks.component.html',
  styleUrls: ['./our-tasks.component.scss'],
  standalone: false,
})
export class OurTasksComponent implements AfterViewInit {
  ngAfterViewInit(): void {
    // Workaround: after page load the first scale-tab-header is autofocussed. The problems cause lies in the
    // telekom scale design system and can be fixed with this workaround:
    setTimeout(
      () =>
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth',
        }),
      100
    );
  }
}
